<script lang="ts">
  import Loading from '$lib/components/Loading.svelte';
  import type { PageProps } from './$types';
  import SkillCategoryBtn from '$lib/components/student/SkillCategoryBtn.svelte';
  let { data, params }: PageProps = $props();
</script>

<div class="d-flex align-items-center mb-3">
  <h3 class="mb-0 flex-grow-1">Skill Categories</h3>
  <a href="/classes/{params.id}/badges/all">See All</a>
</div>
{#await data.classPromise}
  <Loading />
{:then leaderboard}
  {#each leaderboard.class.course.skillCategories as skillCategory (skillCategory.id)}
    <SkillCategoryBtn classId={params.id} category={skillCategory} />
  {/each}
{/await}
